(function () {
  const body = document.body;
  const cartBody = document.getElementById('pkCartBody');
  const subtotalEl = document.getElementById('pkCartSubtotal');
  
  function openCart() {
  body.classList.add('pk-cart-open');
  fetchCart();
}

function closeCart() {
  body.classList.remove('pk-cart-open');
}

  function formatMoney(cents) {
  return `Rs. ${(cents / 100).toFixed(2)}`;
}

/* ===============================
   EXPOSE CART API (IMPORTANT)
================================ */
window.PKCart = {
  open: openCart,
  close: closeCart,
  refresh: fetchCart
};

  async function fetchCart() {
    const res = await fetch('/cart.js');
    const cart = await res.json();

    cartBody.innerHTML = '';

    if (!cart.items.length) {
  cartBody.innerHTML = `
    <div class="pk-cart-empty">
      <div class="pk-cart-empty-icon">🛒</div>
      <h3>Your cart is empty</h3>
      <p>Engineered products await.</p>
      <a href="/collections/aluminium-series" class="pk-cart-empty-cta">
        Explore Aluminium Series
      </a>
    </div>
  `;
  subtotalEl.textContent = '—';
  updateCartBadge(0);
  return;
}


    cart.items.forEach(item => {
  const image = item.image
    ? item.image
    : 'https://cdn.shopify.com/s/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c0c7c1e0b3f07cebfcbf2b3e9f5e6e0.png';

  cartBody.innerHTML += `
    <div class="pk-cart-item" data-key="${item.key}">
  <div class="pk-cart-item-image">
    <img src="${image}" alt="${item.product_title}">
  </div>

  <div class="pk-cart-item-meta">
    <div class="pk-cart-item-title">${item.product_title}</div>
    <div class="pk-cart-item-price">${formatMoney(item.final_price)}</div>

    <div class="pk-cart-item-controls">
      <button class="pk-qty-btn" data-action="decrease">−</button>
      <span class="pk-cart-item-qty">${item.quantity}</span>
      <button class="pk-qty-btn" data-action="increase">+</button>
    </div>
  </div>

  <button class="pk-cart-item-remove" aria-label="Remove item">×</button>
</div>
  `;
});


    subtotalEl.textContent = formatMoney(cart.total_price);
    updateCartBadge(cart.item_count);
  }

  /* ===============================
     CART BADGE SYNC
  ================================ */
  function updateCartBadge(count) {
  const badge = document.querySelector('.pk-cart-dot');
  if (!badge) return;

  if (count > 0) {
    badge.textContent = count > 9 ? '9+' : count;
    badge.style.display = 'flex';
  } else {
    badge.textContent = '0';
    badge.style.display = 'none';
  }
}


  async function updateQuantity(key, quantity) {
  await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity })
  });

  fetchCart();
}


  /* ===============================
     EVENT DELEGATION
  ================================ */
  document.addEventListener('click', (e) => {
  /* ===============================
     CART OPEN
  ================================ */
  if (e.target.closest('.pk-cart-toggle')) {
if (window.PKCart && typeof window.PKCart.open === 'function') {
  window.PKCart.open();
}
    return;
  }

  /* ===============================
     CART CLOSE
  ================================ */
  if (
    e.target.closest('.pk-cart-close') ||
    e.target.id === 'pkCartOverlay'
  ) {
    closeCart();
    return;
  }

  /* ===============================
     CART ITEM ACTIONS
  ================================ */
  const item = e.target.closest('.pk-cart-item');
  if (!item) return;

  const key = item.dataset.key;

  /* Quantity buttons */
  if (e.target.matches('.pk-qty-btn')) {
    const action = e.target.dataset.action;
    const qtyEl = item.querySelector('.pk-cart-item-qty');
    const currentQty = parseInt(qtyEl.textContent, 10);

    if (action === 'increase') updateQuantity(key, currentQty + 1);
    if (action === 'decrease' && currentQty > 1) updateQuantity(key, currentQty - 1);
  }

  /* Remove item */
  if (e.target.matches('.pk-cart-item-remove')) {
    updateQuantity(key, 0);
  }
});


  /* ===============================
     ADD TO CART INTERCEPT
  ================================ */
  document.addEventListener('submit', async (e) => {
    const form = e.target;

    if (!form.matches('form[action="/cart/add"]')) return;

    e.preventDefault();

    const formData = new FormData(form);

    const button = form.querySelector('button[type="submit"]');
button.disabled = true;
button.textContent = 'ADDING…';

await fetch('/cart/add.js', {
  method: 'POST',
  body: formData,
  headers: { 'Accept': 'application/json' }
});

button.textContent = 'ADDED';
setTimeout(() => {
  button.textContent = 'ADD TO CART';
  button.disabled = false;
}, 800);


if (window.PKCart && typeof window.PKCart.open === 'function') {
  window.PKCart.open();
}

  });

  /* ===============================
     INIT CART BADGE ON PAGE LOAD
  ================================ */
  document.addEventListener('DOMContentLoaded', async () => {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      updateCartBadge(cart.item_count);
    } catch (e) {
      console.warn('Cart preload failed');
    }
  });
})();

